// @flow
import React, { useState, useCallback } from 'react';

import { goBack } from '../../lib/helpers';
import { workingHourContractPriceApi } from '../../lib/api';
import { type WorkingHourContractPrice } from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/working-hour-contract-price/';

export default (props: PageProps) => {
  const [data: WorkingHourContractPrice, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, props.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await workingHourContractPriceApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload: WorkingHourContractPrice) => {
    let id = payload.id;
    if (id) {
      await workingHourContractPriceApi.update(payload);
    } else {
      let data = await workingHourContractPriceApi.add(payload);
      id = data.id;
    }
    await goBack(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload: WorkingHourContractPrice) => {
    if (data.id) {
      await goBack(`${entryPointPath}${data.id}`);
    } else await goBack(`${entryPointPath}`);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Стоимость нормо-часа подрядным способом'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
